<template>
  <wsPage title="会议室预约">
    <wsSmPanel :page="table.page"  @page-change="roomList">
      <div slot="query_form">
        <Row class="roomlist">
          <Col span="5">
            状态：
            <Select clearable v-model="workFlowStatus" class="marginTop"  style="width: 60%" @on-change="roomList" >
              <Option v-for="(item,index) in workFlowStatusList" :value="item.dictValue" :key="index">{{ item.dictName}}</Option>
            </Select>
          </Col>
          <Col span="5">
            会议室类型：
            <wsSelect v-model="roomType" dict-code="room_type"  placeholder="请选择" @select-change="changeRoomType"  clearable style="width: 60%"></wsSelect>
          </Col>
          <Col span="6">
            选择日期：
            <DatePicker type="daterange" :editable="false" format="yyyy-MM-dd"  @on-change="dataChange" v-model="startTime"  :value="startTime"   placeholder="请选择" style="width: 60%"></DatePicker>
          </Col>
          <Col span="6" class="btn_search">
            会议室：
            <Input
              search
              enter-button
              @on-search="searchRoom()"
              v-model="roomName"
              placeholder="请输入会议室"
              style="width: 60%"
            />
          </Col>
          <Col span="2">
            <i-button type="primary" class="btn_add" size="small"
                        @click="exportOrders()">导出
          </i-button>
          </Col>
        </Row>
      </div>
      <div slot="list_data">
        <Spin size="large" fix v-if="spinShow"></Spin>
        <Table stripe  ref="table"  max-height="450px"
               :columns="table.columns" :data="table.data"   :loading="loading">

          <template slot-scope="{ row, index }" slot="action">
            <i-button type="primary" class="btn_add" size="small"
                      @click="roomApproval(row.id)">{{row.workFlowStatus === 10 || row.workFlowStatus === 16  ? '处理' : '查看'}}
            </i-button>
          </template>
        </Table>
      </div>
    </wsSmPanel>
  </wsPage>
</template>

<script>
  import { mapState } from 'vuex'
  import {formatDate} from '../js/data'
  export default {
     name: 'roomOrders',
    data() {
      return {
        loading:false,
        table: {
          columns: [
            {
              title: '会议室名称',
              key: 'roomName',
              minWidth: 300,
              tooltip: true,
            },
            {
              title: '位置',
              key: 'floorName',
              minWidth: 60,
              tooltip: true,
            },
            {
              title: '类型',
              key: 'typeName',
              minWidth: 50,
              tooltip: true,
            },
            {
              title: '预约日期',
              key: 'orderDate',
              minWidth: 160,
              tooltip: true,
            },
            {
              title: '预约时间段',
              key: 'orderTime',
              minWidth: 90,
              tooltip: true,
            },
            {
              title: '预约人员',
              key: 'userName',
              minWidth: 70,
              tooltip: true,
            },
            {
              title: '预约人数',
              key: 'personNumber',
              minWidth: 70,
              tooltip: true
            },
            {
              title: '预约公司',
              key: 'companyName',
              minWidth: 90,
              tooltip: true,
            },
            {
              title: '预约部门',
              key: 'departmentName',
              minWidth: 90,
              tooltip: true,
            },
            {
              title: '状态',
              minWidth: 70,
              key: 'statusName',
              tooltip: true,
            },
            {
              title: '操作',
              minWidth: 70,
              slot: 'action'
            }
          ],
          data: [],
          page: {
            total: 0, //总条数
            pageNum: 1, //当前页
            pageSize: 10 //每页显示条数
          },
        },
        spinShow:false,
        roomName:'',
        startTime:'',
        roomType:'',
        workFlowStatus : null,
        workFlowStatusList: []
      }
    },
    computed: {
      ...mapState({
        tagsList: 'tagsList'
      }),
      isFalse(){
        return formatDate(new Date, 'yyyy-MM-dd')
      },
      isTime(){
        return formatDate(new Date, 'hh:mm:ss')
      }
    },
    methods:{
      //审批中
      carApproval(id){
        this.$router.push({
          path: '/resources/carApproval',
          query:{id}
        })
      },
      //状态点击
      roomApproval (id) {
        this.$router.push('/resources/roomApproval/' + id + '/meeting_room/1')
      },
      getWorkFlowStatus() {
        const _this = this
        this.axios.get('ws/resources/getStatus/1').then(function(response) {
          var result = response.data
          if (result.meta.code === 0) {
            _this.workFlowStatusList = result.data
          } else {
            _this.$Message.warning(result.meta.message)
          }
        })
      },
      //会议室列表
      roomList(){
        this.spinShow=true
        let url = this.api.resourcesRoomOrderAll+ "/" + this.table.page.pageNum + "/"+ this.table.page.pageSize;
        this.axios({
          method:'post',
          url:url,
          params: {
            startDate:this.startTime[0],
            endDate:this.startTime[1],
            roomType:this.roomType?this.roomType.toString():'',
            roomName:this.roomName,
            workFlowStatus: this.workFlowStatus ? this.workFlowStatus : null
          }
        }).then((res)=>{
          let result = res.data;
          if (result.meta.code == 0) {
            this.table.data = result.data.list;
            this.table.page.total = result.data.total;
            this.spinShow=false
          } else {
            this.$Message.warning(result.meta.message);
            this.spinShow=false
          }
        }).catch((res)=>{
          this.spinShow=false
          let result = res.data;
          this.$Message.warning(result.meta.message);

        });
      },//会议室列表
      exportOrders(){
        this.spinShow=true
        let url = this.api.exportMeetingOrder;
        this.axios({
          method:'post',
          url:url,
          params: {
            startDate:this.startTime[0],
            endDate:this.startTime[1],
            roomType:this.roomType?this.roomType.toString():'',
            roomName:this.roomName,
            workFlowStatus: this.workFlowStatus ? this.workFlowStatus : null
          }
        }).then((res)=>{
          let result = res.data;
          if (result.meta.code == 0) {
            this.$Message.success(result.meta.message);
            this.spinShow=false
          } else {
            this.$Message.warning(result.meta.message);
            this.spinShow=false
          }
        }).catch((res)=>{
          this.spinShow=false
          let result = res.data;
          this.$Message.warning(result.meta.message);

        });
      },
      //选择日期
      dataChange(e) {
        this.startTime = e;
        this.roomList()
      },
      changeRoomType(){
        this.roomList()
      },
      searchRoom(){
        this.roomList()
      }
    },
		activated(){
			this.roomList()
      this.getWorkFlowStatus()
		},
  }
</script>

<style scoped lang="stylus">
  .approval
    color #666666
  .adopt
    cursor pointer
    color #409eff
  .cancel
    color #C7C7C7
    cursor pointer
</style>
<style>
  .ivu-table-cell {
    padding-left: 5px;
    padding-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/basic/room/roomOrders.vue